import { render, staticRenderFns } from "./nextTicketBlock.vue?vue&type=template&id=1dad9ae4"
import script from "./nextTicketBlock.vue?vue&type=script&lang=js"
export * from "./nextTicketBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports